// extracted by mini-css-extract-plugin
export default {"logo":"group-affiliation-promotion-id-me-button__logo___3ZIn8"};